import { defineStore as e } from "@sunrise/pinia";
const t = e("header", {
  state: () => ({ amount: 0, modalOpen: !1, showDot: !1 })
});
export {
  t as useHeaderStore
};
